import React from "react"

import HomeFAQ from "../../components/HomeFAQ";
import Faq from "../../components/Faq";
import HomeHeader from "../../components/HomeHeader";
import SoftwareService from "../../components/SoftwareService";
import Grid from "@mui/material/Grid";
import HomeHeaderBottomTabs from "../../components/HomeHeaderBottonTabs";

const Home = () => {


    return (


            <Grid >
                <Grid item xs={12}>
                    <HomeHeader/>
                </Grid>
                <Grid item xs={12}>
                    <HomeHeaderBottomTabs/>
                </Grid>
                <Grid item xs={12}>
                    <Faq />
                </Grid>
                <Grid item xs={12}>
                    <HomeFAQ />
                </Grid>
            </Grid>



    );
}
export default Home;


